import {Box, FormControl, IconButton, TextField} from "@mui/material";
import Clear from "@mui/icons-material/Clear";
import Search from "@mui/icons-material/Search";
import React, {useState} from "react";

export type MultiSearchProps<X> = {
    onChange: (search: X[]) => void
    value?: X[],
    label?: string
}


export interface AutocompleteProps<T> {
    name: string
    value: T | null
    setFieldValue: (name: string, value: T | null) => void
    label?: string
    error?: string
}


export type SearchBoxProps = {
    onChange: (search: string) => void
    value: string
    onReset?: () => void
}

/**
 * Search box.
 *
 * search box is a controlled input
 *
 * @param onChange - a set state function to communicate a search
 * @param value - search value
 * @param onReset - event handler to call after reset search is clicked
 * @constructor
 */
export const SearchBox = ({onChange, value, onReset}: SearchBoxProps) => {
    const [show, setShow] = useState(true);
    return <FormControl>
        {show || value ? <Box sx={{display: "flex", alignContent: "flex-end"}}>
            <TextField
                variant="standard"
                sx={{width: {xs: '15ch', sm: "25ch"}, marginTop: "0", marginBottom: "0"}}
                label={"Išči..."}
                id="outlined-adornment-weight"
                value={value}
                onChange={(e) => onChange(e.target.value)}
            />
            <IconButton
                onClick={() => {
                    onChange("")
                    onReset && onReset()
                }}
                sx={{marginTop: "auto"}}
            >
                <Clear/>
            </IconButton>
            <IconButton
                onClick={() => setShow(false)}
                sx={{marginTop: "auto"}}
            ><Search/></IconButton>
        </Box> : <IconButton
            sx={{marginTop: "auto"}}
            onClick={() => setShow(true)}
        ><Search/></IconButton>}
    </FormControl>
}
